export const SET_SELL_ACTIVE_COIN = "SET_SELL_ACTIVE_COIN";
export const SET_SELL_AMOUNT = "SET_SELL_AMOUNT";
export const RESET_SELL_STATE = "RESET_SELL_STATE";
export const REPEAT_SELL_ORDER = "REPEAT_SELL_ORDER";
